export default {
    editable: state => state.editable,
    avaibableLanguages: state => state.avaibableLanguages,
    selectedLanguage: state => state.selectedLanguage,
    translationKeys: state => state.translationKeys
};
